export default __webpack_public_path__ + "static/media/microsoft-team.b57e1ab6.svg";